import React from 'react';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { useNotesSection } from '../hooks';

export default function NotesSection({
  showWaitlistSection,
  waitlistSectionProps,
  applicationNotes,
  prospectUpdateAllowed,
  handleApplicationNotesChange,
  applicationId,
  applicationUpdating,
  isResident,
  isLoading,
}) {
  const {
    isLoading: isNoteSectionLoading,
    reactHookFormProps,
    fields,
  } = useNotesSection({
    waitlistSectionProps,
    applicationNotes,
    showWaitlistSection,
    handleApplicationNotesChange,
    applicationId,
    prospectUpdateAllowed,
    applicationUpdating,
    isResident,
  });

  return (
    <AsyncBox loading={isLoading || isNoteSectionLoading} sx={{ px: 2 }}>
      <Form
        spacing={1}
        ReactHookFormProps={reactHookFormProps}
        fields={fields}
      />
    </AsyncBox>
  );
}
